"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const index_1 = require("./../index");
const Label_1 = require("./Label");
const styled_components_1 = __importDefault(require("styled-components"));
const CheckboxWrapper = styled_components_1.default.div `
  height: 30px;
  display: flex;
  padding-top: 4px;
`;
const Checkbox = (props) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(Label_1.MultiLineLabel, { ...props, required: false }),
    react_1.default.createElement(CheckboxWrapper, null,
        react_1.default.createElement(formik_1.Field, { name: props.name }, (renderProps) => (react_1.default.createElement(index_1.Checkbox, { onChange: renderProps.field.onChange, checked: !!renderProps.field.value, name: renderProps.field.name, id: renderProps.field.name, symbol: props.symbol, title: props.title }))))));
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map